import { type GtmPopupParams, gtmSignInSuccess, gtmSignUpSuccess } from './gtmTracking';

type GtmSignEventArgs = GtmPopupParams & {
  // reply flag: `created` (popup/landing) or `first_verified` (/verify); missing = false
  isNewUser?: boolean;
  // reply flag `ems_first_grant`; missing = false
  emsFirstGrant?: boolean;
};

// Emits exactly one of sign_up_success / sign_in_success; never throws so analytics can't break login.
export const gtmSignSuccess = ({ isNewUser, emsFirstGrant, ...popupParams }: GtmSignEventArgs) => {
  try {
    if (isNewUser === true) {
      gtmSignUpSuccess({ ...popupParams, emailGranted: emsFirstGrant === true });
      return;
    }
    gtmSignInSuccess(popupParams);
  } catch (error) {
    console.error('gtmSignSuccess', error);
  }
};
